<script>
  export default {
    props: {
      template: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        renderer: null,
      };
    },
    render: function () {
      let template = App.Vue.compile(this.template);
      this.renderer = template.render;

      // staticRenderFns belong into $options, appearantly
      this.$options.staticRenderFns = [];

      // clean the cache of static elements
      // this is a cache of the results from the staticRenderFns
      this._staticTrees = [];

      // Fill it with the new staticRenderFns
      template.staticRenderFns.forEach(fn => this.$options.staticRenderFns.push(fn));

      return this.renderer();
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/content/assets/js/components/BuilderRuntimeTemplate.vue